import { useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { SHORTLIST_PURPOSES } from '../../lib/taxonomy';

/** Controlled-ish form fields for a shortlist. Calls onSubmit(values). */
export default function ShortlistForm({ initial = {}, onSubmit, id = 'shortlist-form', autoFocus }) {
  const [v, setV] = useState({
    name: initial.name || '',
    purpose: initial.purpose || 'b2b_project',
    client: initial.client || '',
    notes: initial.notes || '',
  });
  const set = (k) => (e) => setV((s) => ({ ...s, [k]: e?.target ? e.target.value : e }));
  return (
    <form
      id={id}
      className="space-y-3"
      onSubmit={(e) => {
        e.preventDefault();
        if (v.name.trim()) onSubmit({ ...v, name: v.name.trim() });
      }}
    >
      <div className="space-y-1.5">
        <Label htmlFor={`${id}-name`}>Name</Label>
        <Input id={`${id}-name`} value={v.name} onChange={set('name')} placeholder="e.g. Hotel Amigo — lobby refresh" autoFocus={autoFocus} required />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label>Purpose</Label>
          <Select value={v.purpose} onValueChange={set('purpose')}>
            <SelectTrigger className="h-10">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {Object.entries(SHORTLIST_PURPOSES).map(([k, m]) => (
                <SelectItem key={k} value={k}>
                  {m.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={`${id}-client`}>Client</Label>
          <Input id={`${id}-client`} value={v.client} onChange={set('client')} placeholder="Optional" />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor={`${id}-notes`}>Notes</Label>
        <Textarea id={`${id}-notes`} value={v.notes} onChange={set('notes')} placeholder="Context, deadline, budget…" rows={3} />
      </div>
    </form>
  );
}
